import { R } from '@/config/siteRoutes';

/** 反无人机板块侧栏 / 顶栏共用导航 */
export const antidroneNav = [
  {
    key: 'detect',
    name: '侦测系列',
    nameEn: 'Detection Series',
    path: R.PRODUCTS,
    query: { cat: 'detect' }
  },
  {
    key: 'jamming',
    name: '干扰系列',
    nameEn: 'Jamming Series',
    path: R.PRODUCTS,
    query: { cat: 'jamming' }
  },
  {
    key: 'intercept',
    name: '物理拦截系列',
    nameEn: 'Physical Interception',
    path: R.PRODUCTS,
    query: { cat: 'intercept' }
  },
  {
    key: 'integrated',
    name: '侦反一体系列',
    nameEn: 'Integrated Detection & Countermeasure',
    path: R.PRODUCTS,
    query: { cat: 'integrated' }
  },
  {
    key: 'platform',
    name: '低空安全管理平台',
    nameEn: 'Low-Altitude Security Platform',
    path: R.SOLUTION_CUAS
  },
  {
    key: 'position',
    name: '产品定位矩阵',
    nameEn: 'Product Positioning Matrix',
    path: R.PRODUCT_MATRIX
  },
  {
    key: 'capability',
    name: '产品能力矩阵',
    nameEn: 'Product Capability Matrix',
    path: R.PRODUCT_CAPABILITY
  },
  {
    key: 'solution',
    name: '解决方案',
    nameEn: 'Solutions',
    path: R.PRODUCTS,
    query: { cat: 'solution' }
  }
];

export function resolveAntidroneActiveKey(route) {
  const path = route.path;
  if (path === R.PRODUCT_MATRIX) return 'position';
  if (path === R.PRODUCT_CAPABILITY || path === R.SOLUTION_DRONE) return 'capability';
  if (path === R.SOLUTION_CUAS) return 'platform';
  if (
    path === R.SOLUTION_CUAS_ZH ||
    path === R.SOLUTION_CUAS_EN
  ) {
    return 'solution';
  }
  if (path === R.PRODUCT_INTEGRATED) {
    return route.query.cat || 'detect';
  }
  if (path === R.PRODUCTS) {
    return route.query.cat || 'detect';
  }
  return '';
}
